import React from "react";

import ChangeHistoryModal from "../../../components/ChangeHistory";
import { API_ENDPOINTS } from "../../../constant/_constant";

/*
 * Tabs mirror the order edit form. Keys must match ORDER_HISTORY_TABS in
 * backend/controllers/Order/OrderChangeHistoryController.js.
 */
export const ORDER_HISTORY_TABS = [
  { key: "all", label: "All" },
  { key: "status", label: "Status Change" },
  { key: "general", label: "General" },
  { key: "billing_shipping", label: "Billing & Shipping" },
  /* Sales and purchasing lines share this tab, so cards name their section. */
  { key: "products", label: "Products", showSection: true },
  { key: "payment_cards", label: "Payment Cards" },
  { key: "packing_slips", label: "Packing Slips" },
  { key: "attachments", label: "Attachments" },
  { key: "notes", label: "Notes" },
  { key: "other", label: "Other" },
];

/**
 * Order change history. Same props as the component it replaces
 * (Product_Revistion_order), so listings only swap the element.
 */
function OrderChangeHistoryModal({ show, setShow, orderSku }) {
  return (
    <ChangeHistoryModal
      show={show}
      onHide={() => setShow({ show: false })}
      title="Change History"
      subtitle={
        <>
          Order ID: <strong>{orderSku}</strong>
        </>
      }
      tabs={ORDER_HISTORY_TABS}
      endpoint={API_ENDPOINTS.GET_ORDER_CHANGE_HISTORY}
      basePayload={{ order_id: orderSku }}
    />
  );
}

export default OrderChangeHistoryModal;
